import { TagAlertsVerboseList } from "../Clusters/Information/TagAlerts";
import React from "react";
import { useAllAlertContents } from "../../crud/tags/hooks";

export const TagAlertPreview = (): React.ReactElement => {
  const { data: allAlerts } = useAllAlertContents();
  return <TagAlertsVerboseList alertList={allAlerts || []} />;
};
